import { z } from 'zod';

import { payApi } from '@/services/api';
import {
  BeneficiarySchema,
  BeneficiaryCreateResponseSchema,
  BeneficiaryFormSchema,
  BeneficiaryIdPathSchema,
  BeneficiaryDetailsQuerySchema,
  BeneficiaryCreateBodySchema,
  BeneficiaryUpdateBodySchema,
  VendorIdPathSchema,
  VendorFieldBodySchema,
  VendorFieldResponseSchema,
  BeneficiariesGridHeadersSchema,
  BeneficiariesGridTotalSchema,
  BeneficiariesGridSearchBodySchema,
  BeneficiariesGridSearchResponseSchema,
} from '@/domain/payments/schemas';

export const beneficiariesApi = {
  // Reads
  getForm: payApi.endpoint({
    method: 'GET',
    url: 'beneficiaries/form',
    response: BeneficiaryFormSchema,
  }),
  getDetails: payApi.endpoint({
    method: 'GET',
    url: (p: { id: string }) => `beneficiaries/${p.id}`,
    path: BeneficiaryIdPathSchema,
    query: BeneficiaryDetailsQuerySchema,
    response: BeneficiarySchema,
  }),
  getGridHeaders: payApi.endpoint({
    method: 'GET',
    url: 'grid/beneficiaries/headers',
    response: BeneficiariesGridHeadersSchema,
  }),
  getGridTotal: payApi.endpoint({
    method: 'GET',
    url: 'grid/beneficiaries/total',
    response: BeneficiariesGridTotalSchema,
  }),
  gridSearch: payApi.endpoint({
    method: 'POST',
    url: 'grid/beneficiaries/search',
    body: BeneficiariesGridSearchBodySchema,
    response: BeneficiariesGridSearchResponseSchema,
  }),
  // Writes
  create: payApi.endpoint({
    method: 'POST',
    url: 'beneficiaries',
    body: BeneficiaryCreateBodySchema,
    // POST returns only { id } — not the full entity.
    response: BeneficiaryCreateResponseSchema,
  }),
  update: payApi.endpoint({
    method: 'PATCH',
    url: (p: { id: string }) => `beneficiaries/${p.id}`,
    path: BeneficiaryIdPathSchema,
    body: BeneficiaryUpdateBodySchema,
    // Response not consumed (set-default/edit just refetch); payment-API writes
    // return minimal/varying bodies, so don't validate against the full entity.
    response: z.unknown(),
  }),
  updateVendorField: payApi.endpoint({
    method: 'PATCH',
    url: (p: { vendorId: string }) => `grid/vendors/${p.vendorId}/withholding-tax`,
    path: VendorIdPathSchema,
    body: VendorFieldBodySchema,
    response: VendorFieldResponseSchema,
  }),
  remove: payApi.endpoint({
    method: 'DELETE',
    url: (p: { id: string }) => `beneficiaries/${p.id}`,
    path: BeneficiaryIdPathSchema,
    response: z.unknown(),
  }),
};
